<template>
    <div class="" style="margin-left: 75px">
        <d-site
            v-model  = "dialog"
            :site-id = "siteId"
            @saved   = "onSaved"
        />

        <c-app-bar
            title          = "ANLAGEN"
            :categories    = "['site']"
            :enable-search = "false"
        >
            <template slot="search">
                <m-site-search
                    class   = "ml-2"
                    @search = "onSearch"
                />
                <v-spacer />
            </template>
        </c-app-bar>

        <c-customer-index
            :minimize      = "false"
            :enable-search = "true"
            :filter-height = "225"
            @changed       = "onCustomer"
            style          = "padding-right: 75px;"
        >
            <template v-slot:detail="{  }">
                <m-site-table
                    :customer = "customerId"
                    :data     = "data"
                    @selected = "onSite"
                    ref       = "table"
                />
            </template>
        </c-customer-index>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import CCustomerIndex from "@/modules/msd/company/customer/components/controlls/CCustomerIndex";
import MSiteTable     from "@/modules/msd/unit/components/main/MSiteTable";
import DSite          from "@/modules/msd/unit/components/dialog/DSite";
import CAppBar        from "@/modules/core/components/app/CAppBar";
import MSiteSearch    from "@/modules/msd/unit/components/main/MSiteSearch";

export default {
    name: "MSite",
    components: {
        MSiteSearch,
        CAppBar,
        DSite,
        MSiteTable,
        CCustomerIndex,
    },

    data: () => ({
        dialog: false,
        siteId: null,
        customerId: null,
        data : null,
        timeoutHandle: null,
    }),

    mounted() {
        Core.init.load(this.$store, false).then(() => {
        })
    },

    methods: {
        onCustomer (customer) {
            if (!customer && customer !== 0) {
                this.customerId = null;
                return;
            }

            this.customerId = customer.id;
        },

        onSearch (options) {
            this.data = options;
        },

        onSite (site) {
            this.siteId = site.id;
            this.dialog = true;
        },

        onSaved(site) {
            this.$refs.table.refresh(site);
        }
    }
}

</script>

<style scoped>

</style>